import React from 'react';

export default ({ size }) => (
  <svg
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path
      fill="currentColor"
      d="M138.239 322.56l117.761 117.76 117.76-117.76 35.84 35.84-153.6 153.6-153.6-153.6 35.84-35.84zM138.239 189.44l117.761-117.76 117.76 117.76 35.84-35.84-153.6-153.6-153.6 153.6 35.84 35.84z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/SelectArrows.js